import { handleActions } from 'redux-actions'
import {
  hasError,
  isLoading,
  data,
  setDataUrlRenovaciones,
  setDataServicios,
  setServiciosIsLoading,
  setServiciosHasError,
} from '../actions/aMenus';
import { SET_DATA_USUARIO } from '../actions/aLogin';


export const datosProductosMenu =  handleActions(
  {
    [isLoading]: (state) => { return { ...state, isLoading: true, hasError: '' }; },
    [hasError]: (state,action) => ({ ...state, hasError: action.payload, isLoading: false, data: [] }),
    [data]: (state, action) => ({ ...state, isLoading: false, data: action.payload, date: new Date() }),
    [setDataUrlRenovaciones]: (state, action) => ({ ...state, setDataUrlRenovaciones: action.payload})
  },
  {
    isLoading: false,
    hasError: '',
    data: [],
    date: '',
    setDataUrlRenovaciones:''
  }
);

export const rServicios = handleActions(
  {
    [setDataServicios]: (state, action) => {
      const payload = action.payload;
      const dataServicios = Array.isArray(payload) ? payload : (payload && payload.enlaces) || [];
      const userId = payload && payload.userId !== undefined ? payload.userId : state.userId;
      return {
        ...state,
        serviciosIsLoading: false,
        dataServicios,
        userId,
        date: new Date()
      };
    },
    [setServiciosIsLoading]: (state) => { return { ...state, serviciosIsLoading: true, serviciosHasError: '' }; },
    [setServiciosHasError]: (state, action) => ({ ...state, serviciosHasError: action.payload, serviciosIsLoading: false, dataServicios: [], userId: null, date: '' }),
    [SET_DATA_USUARIO]: (state, action) => {
      if (!action.payload || action.payload.userIsLoggedIn === false) {
        return {
          dataServicios: [],
          serviciosIsLoading: false,
          serviciosHasError: '',
          date: '',
          userId: null,
        };
      }
      return state;
    },
  },
  {
    dataServicios: [],
    serviciosIsLoading: false,
    serviciosHasError: '',
    date: '',
    userId: null,
  }
);